import "./App.css";
import Header from "./components/Header";
import Options from "./components/Options";
import Text from "./components/Text";

function App() {
  return (
    <div className="container mx-auto App">
      <Header />
      <Options />
      <Text />
    </div>
  );
}

export default App;
